var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getBreed } from '@spike/breed-utils';
import { VaccineStatus, } from '@spike/medical-history-model';
import { PetTypeIds } from '@spike/model';
import capitalize from 'lodash/capitalize';
import moment from 'moment-timezone';
import { NoteCreatorType, } from './PetsDtos';
import isEmpty from 'lodash/isEmpty';
export var convertToPet = function (masterData, marketplace, timeZone, petDto) {
    var _a, _b, _c, _d, _e;
    var clientDto = petDto.owners[0];
    return {
        id: petDto.id,
        uuid: petDto.uuid,
        name: petDto.name,
        type: masterData.petTypes.find(function (pt) { return pt.id === petDto.pet_type; }),
        hair: getPetHairType(masterData, petDto.pet_type, petDto.pet_hair_type),
        hairLength: getPetHairLength(masterData, petDto.pet_type, petDto.pet_hair_length),
        color: getPetColor(masterData, petDto.pet_type, petDto.pet_hair_color),
        breed: petDto.pet_breed ? getBreed(petDto.pet_breed, petDto.pet_type, masterData) : undefined,
        exoticType: petDto.exotic_type ? getExoticType(marketplace, petDto.exotic_type) : undefined,
        size: isEmpty(petDto.pet_size) ? undefined : { id: petDto.pet_size, name: (_a = petDto.pet_size_name) !== null && _a !== void 0 ? _a : '' },
        weight: petDto.pet_weight,
        gender: masterData.petGenders.find(function (g) { return g.id === petDto.pet_gender; }),
        age: masterData.ageOptions.find(function (a) { return a.id === petDto.age; }),
        birthdate: petDto.birthdate === null ? undefined : moment.tz(petDto.birthdate, 'Zulu'),
        groomingNotes: petDto.grooming_notes,
        notes: convertToNotes(petDto.notes, timeZone),
        allergies: petDto.allergies,
        deceased: petDto.deceased,
        active: petDto.active,
        personalities: petDto.pet_behavioral_conditions
            ? petDto.pet_behavioral_conditions.map(function (condition) { return convertPersonality(masterData, condition); })
            : [],
        medicalHistory: {
            dentals: petDto.pet_dental_histories
                ? petDto.pet_dental_histories.map(function (dental) { return convertPetDentalHistory(masterData, dental); })
                : [],
            medicalConditions: petDto.pet_conditions
                ? petDto.pet_conditions.map(function (cond) { return convertPetCondition(masterData, cond); })
                : [],
            vaccines: ((_b = petDto.pet_vaccine_expirations) === null || _b === void 0 ? void 0 : _b.map(function (vaccineDto) { return ({
                id: vaccineDto.id || undefined,
                uuid: vaccineDto.uuid,
                type: masterData.vaccines.some(function (vaccine) { return vaccine.id === vaccineDto.vaccine_id; }) ? __assign({}, masterData.vaccines.find(function (vaccine) { return vaccine.id === vaccineDto.vaccine_id; })) :
                    { id: vaccineDto.vaccine_id, name: vaccineDto.vaccine_id.split('_').map(function (token) { return capitalize(token); }).join(' ') },
                expiration: vaccineDto.expiration_date === null ? undefined : moment.tz(vaccineDto.expiration_date, 'Zulu'),
                status: vaccineDto.expiration_date === null ? VaccineStatus.MISSING_EXPIRATION : (moment().isAfter(moment.tz(vaccineDto.expiration_date, 'Zulu')) ? VaccineStatus.EXPIRED : VaccineStatus.ACTIVE),
                record: vaccineDto.file_url
                    ? {
                        url: vaccineDto.file_url,
                        fileName: vaccineDto.file_name,
                        file: new File([vaccineDto.file_url], vaccineDto.file_name),
                    }
                    : undefined,
            }); })) || [],
        },
        image: petDto.image_url,
        clientId: clientDto.id,
        clientName: "".concat(clientDto.first_name, " ").concat(clientDto.last_name),
        deleted: petDto.deleted,
        nextAppointmentId: petDto.next_appointment_id,
        nextAppointmentDate: petDto.next_appointment_date,
        lastAppointmentId: petDto.last_appointment_id,
        lastAppointmentDate: petDto.last_appointment_date,
        destroyable: petDto.destroyable,
        vetId: petDto.vet_id === null ? undefined : petDto.vet_id,
        hasMedicalConditions: petDto.has_medical_conditions || false,
        customQuestionResponses: ((_c = petDto.custom_question_responses) === null || _c === void 0 ? void 0 : _c.map(function (response) { return convertCustomQuestionResponse(response, timeZone); })) || [],
        positivePersonalities: ((_d = petDto.positive_personalities) === null || _d === void 0 ? void 0 : _d.map(function (response) { return convertToPetTag(response); })) || [],
        positivePersonalitiesList: petDto.positive_personality_list,
        negativePersonalities: ((_e = petDto.negative_personalities) === null || _e === void 0 ? void 0 : _e.map(function (response) { return convertToPetTag(response); })) || [],
        negativePersonalitiesList: petDto.negative_personality_list,
    };
};
export var getPetHairType = function (masterData, petTypeId, petHairTypeId) {
    var _a, _b;
    switch (petTypeId) {
        case PetTypeIds.DOGS:
            return (_a = masterData.dogHairTypes.find(function (hairType) { return hairType.element.id === petHairTypeId; })) === null || _a === void 0 ? void 0 : _a.element;
        case PetTypeIds.CATS:
            return (_b = masterData.catHairTypes.find(function (hairType) { return hairType.element.id === petHairTypeId; })) === null || _b === void 0 ? void 0 : _b.element;
        default:
            return undefined;
    }
};
export var getPetHairLength = function (masterData, petTypeId, petHairLengthId) {
    var _a, _b;
    switch (petTypeId) {
        case PetTypeIds.DOGS:
            return (_a = masterData.dogHairLengths.find(function (hairLength) { return hairLength.element.id === petHairLengthId; })) === null || _a === void 0 ? void 0 : _a.element;
        case PetTypeIds.CATS:
            return (_b = masterData.catHairLengths.find(function (hairLength) { return hairLength.element.id === petHairLengthId; })) === null || _b === void 0 ? void 0 : _b.element;
        default:
            return undefined;
    }
};
export var getPetColor = function (masterData, petTypeId, petColorId) {
    switch (petTypeId) {
        case PetTypeIds.DOGS:
            return masterData.dogColors.find(function (color) { return color.id === petColorId; });
        case PetTypeIds.CATS:
            return masterData.catColors.find(function (color) { return color.id === petColorId; });
        case PetTypeIds.EXOTICS:
            return masterData.exoticColors.find(function (color) { return color.id === petColorId; });
        default:
            return undefined;
    }
};
var convertPetCondition = function (masterData, petConditionDto) {
    var _a, _b, _c;
    return {
        id: petConditionDto.id,
        medicalConditionCategoryId: petConditionDto.medical_condition_category_id,
        categoryName: ((_a = masterData.medicalHistory.medicalConditionCategories.find(function (cat) { return cat.id === petConditionDto.medical_condition_category_id; })) === null || _a === void 0 ? void 0 : _a.name) || '',
        medicalConditionId: petConditionDto.medical_condition_id,
        conditionName: ((_c = (_b = masterData.medicalHistory.medicalConditionCategories
            .find(function (cat) { return cat.id === petConditionDto.medical_condition_category_id; })) === null || _b === void 0 ? void 0 : _b.options.find(function (cond) { return cond.id === petConditionDto.medical_condition_id; })) === null || _c === void 0 ? void 0 : _c.name) || '',
        explanation: petConditionDto.explanation,
        medications: petConditionDto.medications,
        howLongAgo: masterData.ageOptions.find(function (a) { return a.id === petConditionDto.how_long_ago; }),
    };
};
var convertPersonality = function (masterData, petBehavioralConditionDto) {
    var _a, _b, _c;
    return {
        id: petBehavioralConditionDto.id,
        categoryId: petBehavioralConditionDto.behavior_condition_category_id,
        categoryIcon: (_a = masterData.medicalHistory.behaviorConditionCategories.find(function (category) { return category.id === petBehavioralConditionDto.behavior_condition_category_id; })) === null || _a === void 0 ? void 0 : _a.icon,
        conditionId: petBehavioralConditionDto.behavior_condition_id,
        conditionName: ((_c = (_b = masterData.medicalHistory.behaviorConditionCategories
            .find(function (category) { return category.id === petBehavioralConditionDto.behavior_condition_category_id; })) === null || _b === void 0 ? void 0 : _b.options.find(function (condition) { return condition.id === petBehavioralConditionDto.behavior_condition_id; })) === null || _c === void 0 ? void 0 : _c.name) || '',
    };
};
var convertPetDentalHistory = function (masterData, petDentalHistoryDto) {
    var _a;
    return {
        id: petDentalHistoryDto.id,
        dentalId: petDentalHistoryDto.pet_history_type,
        name: ((_a = masterData.medicalHistory.dentals.find(function (d) { return d.id === petDentalHistoryDto.pet_history_type; })) === null || _a === void 0 ? void 0 : _a.name) || '',
        cleaningDate: petDentalHistoryDto.cleaning_date ? moment.tz(petDentalHistoryDto.cleaning_date, 'Zulu') : undefined,
        teethExtracted: petDentalHistoryDto.teeth_extracted,
    };
};
export var convertPetMedicalConditionToDto = function (marketplaceId, petMedicalCondition) {
    var _a;
    return {
        id: petMedicalCondition.id,
        marketplace_id: marketplaceId,
        medical_condition_category_id: petMedicalCondition.medicalConditionCategoryId,
        medical_condition_id: petMedicalCondition.medicalConditionId,
        explanation: petMedicalCondition.explanation,
        medications: petMedicalCondition.medications,
        how_long_ago: (_a = petMedicalCondition.howLongAgo) === null || _a === void 0 ? void 0 : _a.id,
    };
};
export var convertPersonalitiesToDto = function (marketplaceId, petPersonalities, actualPet) {
    var _a;
    var personalities = petPersonalities.map(function (personality) { return convertPersonalityToDto(marketplaceId, personality); });
    var removedPersonalities = ((_a = actualPet === null || actualPet === void 0 ? void 0 : actualPet.personalities) !== null && _a !== void 0 ? _a : []).filter(function (actualPersonality) { return !petPersonalities.some(function (personality) { return personality.id === actualPersonality.id; }); }).map(function (actualPersonality) { return ({ id: actualPersonality.id, _destroy: true }); });
    return __spreadArray(__spreadArray([], personalities, true), removedPersonalities, true);
};
export var convertPersonalityToDto = function (marketplaceId, petPersonality) {
    return {
        id: petPersonality.id,
        marketplace_id: marketplaceId,
        behavior_condition_category_id: petPersonality.categoryId,
        behavior_condition_id: petPersonality.conditionId,
    };
};
export var convertPetDentalToDto = function (marketplaceId, petDental) {
    var _a;
    return {
        id: petDental.id,
        marketplace_id: marketplaceId,
        pet_history_type: petDental.dentalId,
        cleaning_date: (_a = petDental.cleaningDate) === null || _a === void 0 ? void 0 : _a.format('YYYY-MM-DD'),
        teeth_extracted: petDental.teethExtracted,
    };
};
export var convertMedicalHistoryToDto = function (marketplaceId, currentPet, medicalHistory) {
    var _a, _b, _c, _d;
    var medicalConditionsDto = __spreadArray(__spreadArray([], ((_a = medicalHistory.medicalConditions) !== null && _a !== void 0 ? _a : []).map(function (mc) { return convertPetMedicalConditionToDto(marketplaceId, mc); }), true), toDestroy(__spreadArray([], currentPet.medicalHistory.medicalConditions, true), medicalHistory.medicalConditions), true);
    var dentalsDto = __spreadArray(__spreadArray([], ((_b = medicalHistory.dentals) !== null && _b !== void 0 ? _b : []).map(function (d) { return convertPetDentalToDto(marketplaceId, d); }), true), toDestroy(currentPet.medicalHistory.dentals, medicalHistory.dentals), true);
    var vaccinesDto = __spreadArray(__spreadArray([], ((_c = medicalHistory.vaccines) !== null && _c !== void 0 ? _c : []).map(function (vaccine) { return convertPetVaccineToDto(marketplaceId, vaccine, currentPet.id); }), true), ((_d = currentPet.medicalHistory.vaccines) !== null && _d !== void 0 ? _d : [])
        .filter(function (currentVaccine) {
        return !medicalHistory.vaccines.some(function (unsavedVaccine) { return currentVaccine.uuid === unsavedVaccine.uuid; });
    })
        .map(function (deletedVaccine) { return ({ id: deletedVaccine.id, _destroy: true }); }), true);
    return {
        id: currentPet.id,
        pet_conditions_attributes: medicalConditionsDto,
        pet_dental_histories_attributes: dentalsDto,
        pet_vaccine_expirations_attributes: vaccinesDto,
    };
};
export var convertPetVaccineToDto = function (marketplaceId, vaccine, petId) {
    var _a, _b, _c, _d, _e;
    return {
        id: vaccine.id || null,
        uuid: vaccine.uuid,
        marketplace_id: marketplaceId,
        pet_id: petId,
        vaccine_id: (_a = vaccine.type) === null || _a === void 0 ? void 0 : _a.id,
        expiration_date: (_b = vaccine.expiration) === null || _b === void 0 ? void 0 : _b.format('YYYY-MM-DD'),
        //@ts-ignore
        file: ((_c = vaccine.record) === null || _c === void 0 ? void 0 : _c.remove) ? new Blob() : ((_d = vaccine.record) === null || _d === void 0 ? void 0 : _d.upload) ? vaccine.record.file : undefined,
        remove_file: (_e = vaccine.record) === null || _e === void 0 ? void 0 : _e.remove
    };
};
var toDestroy = function (current, updates) {
    var ids = (updates !== null && updates !== void 0 ? updates : []).map(function (u) { return u.id; });
    return (current !== null && current !== void 0 ? current : []).filter(function (c) { return !ids.includes(c.id); }).map(function (c) { return ({ id: c.id, _destroy: true }); });
};
export var getExoticType = function (marketplace, exoticTypeId) {
    var marketplaceExotics = (marketplace === null || marketplace === void 0 ? void 0 : marketplace.petTypes.exotics) || { types: [], others: [] };
    var exoticType = marketplaceExotics.types.find(function (type) { return type.id === exoticTypeId; });
    return exoticType ? exoticType : { id: exoticTypeId, name: exoticTypeId };
};
var convertToNotes = function (noteDtos, timeZone) {
    return noteDtos.map(function (dto) { return ({
        id: dto.id,
        uuid: dto.uuid,
        body: dto.message,
        author: dto.creator_name,
        staffId: dto.creator_type.toLowerCase() === NoteCreatorType.STAFF.toString().toLowerCase() ? dto.creator_id : undefined,
        clientId: dto.creator_type.toLowerCase() === NoteCreatorType.CLIENT.toString().toLowerCase() ? dto.creator_id : undefined,
        createdAt: moment(dto.created_at).tz(timeZone),
        updatedAt: moment(dto.updated_at).tz(timeZone),
    }); });
};
export var convertToSavePetDto = function (marketplaceId, pet, actualPet) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return {
        id: pet.id,
        uuid: pet.uuid,
        marketplace_id: marketplaceId,
        name: pet.name,
        birthdate: (_a = pet.birthdate) === null || _a === void 0 ? void 0 : _a.format('YYYY-MM-DD'),
        age: (_b = pet.age) === null || _b === void 0 ? void 0 : _b.id,
        pet_type: (_c = pet.type) === null || _c === void 0 ? void 0 : _c.id,
        pet_weight: (_d = pet.weight) !== null && _d !== void 0 ? _d : null,
        pet_size: ((_e = pet.type) === null || _e === void 0 ? void 0 : _e.id) === PetTypeIds.DOGS ? null : (_f = pet.size) === null || _f === void 0 ? void 0 : _f.id,
        pet_breed: pet.breed === undefined ? null : (_g = pet.breed) === null || _g === void 0 ? void 0 : _g.id,
        exotic_type: pet.exoticType === undefined ? null : (_h = pet.exoticType) === null || _h === void 0 ? void 0 : _h.id,
        pet_gender: (_j = pet.gender) === null || _j === void 0 ? void 0 : _j.id,
        pet_hair_type: pet.hair === undefined ? null : (_k = pet.hair) === null || _k === void 0 ? void 0 : _k.id,
        pet_hair_length: pet.hairLength === undefined ? null : (_l = pet.hairLength) === null || _l === void 0 ? void 0 : _l.id,
        pet_hair_color: pet.color === undefined ? null : (_m = pet.color) === null || _m === void 0 ? void 0 : _m.id,
        pet_vaccine_expirations_attributes: pet.id
            ? []
            : pet.medicalHistory.vaccines.map(function (vaccine) { return convertPetVaccineToDto(marketplaceId, vaccine, pet.id); }),
        grooming_notes: pet.groomingNotes || '',
        notes_attributes: pet.notes.map(function (note) { return convertToSaveNoteDto(note); }),
        allergies: pet.allergies || '',
        active: pet.active,
        deceased: pet.deceased,
        positive_personality_list: pet.positivePersonalitiesList,
        negative_personality_list: pet.negativePersonalitiesList,
        pet_behavioral_conditions_attributes: convertPersonalitiesToDto(marketplaceId, pet.personalities, actualPet),
        pet_conditions_attributes: pet.id
            ? []
            : pet.medicalHistory.medicalConditions.map(function (mc) { return convertPetMedicalConditionToDto(marketplaceId, mc); }),
        pet_dental_histories_attributes: pet.id
            ? []
            : pet.medicalHistory.dentals.map(function (d) { return convertPetDentalToDto(marketplaceId, d); }),
        //@ts-ignore
        image: pet.imageRemoved ? new Blob() : pet.imageFileToUpload,
        remove_image: pet.imageRemoved,
        owns_attributes: [{ customer_id: pet.clientId }],
        vet_id: pet.vetId,
    };
};
export var convertToSaveNoteDto = function (note) { return ({
    id: note.id,
    uuid: note.uuid,
    message: note.body,
    creator_id: note.clientId || note.staffId,
    creator_type: note.clientId
        ? NoteCreatorType.CLIENT.toString()
        : note.staffId
            ? NoteCreatorType.STAFF.toString()
            : undefined,
}); };
var convertCustomQuestionResponse = function (cqr, timeZone) {
    return {
        id: cqr.id,
        answer: cqr.answer,
        question: cqr.question_snapshot,
        questionId: cqr.custom_question_id,
        responseableId: cqr.responseable_id,
        responseableType: cqr.responseable_type,
        updatedAt: moment(cqr.updated_at).tz(timeZone),
        createdAt: moment(cqr.created_at).tz(timeZone),
    };
};
export var convertToPetTag = function (petTag) { return ({
    id: petTag.id,
    name: petTag.name,
}); };
